import script from "./AddChallan.vue?vue&type=script&setup=true&lang=js"
export * from "./AddChallan.vue?vue&type=script&setup=true&lang=js"

import "./AddChallan.vue?vue&type=style&index=0&id=4d0124e7&lang=css"

const __exports__ = script;

export default __exports__